/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

const useFetchDetalleExpediente = (expediente) => {
  const [response, setResponse] = useState()
  const [error, setError] = useState()
  const [loading, setLoading] = useState()

  const fetchData = useCallback(() => {
    if (loading || !expediente?.numero_expediente) return
    setLoading((loading) => {
      return true
    })

    axios
      .post(`/expedienteslisa/getDatosExpediente/`, expediente)
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() =>
        setLoading((loading) => {
          return false
        }),
      )
  }, [expediente])

  useEffect(() => {
    if (!loading) fetchData()
  }, [])

  return { response, error, loading }
}

export default useFetchDetalleExpediente
